// Auto-generated from the Outline 'Alturex Work — Help Center' public share.
// Update HELP_CENTER_URL if the Outline share is re-created.
export const HELP_CENTER_URL = 'https://docs.alturex.com/s/a9558566-05c8-47aa-b3ea-c6a45df41726';

/** Deep links into specific help guides (public Outline share). */
export const HELP_DOCS = {
  gettingStarted: `${HELP_CENTER_URL}/doc/getting-started-V9WTUXBSne`,
  dashboard: `${HELP_CENTER_URL}/doc/dashboard-home-xYjgWDevks`,
  board: `${HELP_CENTER_URL}/doc/board-sites-Nlgrl9DjZ3`,
  tickets: `${HELP_CENTER_URL}/doc/work-tickets-7pdZPs2Rvg`,
  catalog: `${HELP_CENTER_URL}/doc/catalog-kits-orJcl51Hfb`,
  review: `${HELP_CENTER_URL}/doc/review-approval-40NReRMfHh`,
  invoicing: `${HELP_CENTER_URL}/doc/invoicing-quickbooks-i3jAwLR7TC`,
  sales: `${HELP_CENTER_URL}/doc/sales-customers-wZGteyndYU`,
  reports: `${HELP_CENTER_URL}/doc/reports-CKfXgL0Ssu`,
  team: `${HELP_CENTER_URL}/doc/team-management-qYGE7Zjkvw`,
  admin: `${HELP_CENTER_URL}/doc/admin-khgZ5EPATJ`,
  // #1011: point these at the published Outline documents once
  // docs/knowledge-base/safety-and-compliance.md and my-documents.md are
  // published (docs/help-center-publication.md); the help center home until then.
  safety: HELP_CENTER_URL,
  myDocuments: HELP_CENTER_URL,
} as const;

export type HelpDocKey = keyof typeof HELP_DOCS;
